export default __webpack_public_path__ + "static/media/t1_active.13b63805.png";